let _ = t => t,
  _t;
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import UIImage from 'UIComponents/image/UIImage';
import breakpoint from 'pricing-pages-ui/js/constants/Breakpoints';
import { MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import styled from 'styled-components';
import { TRIAL_UPGRADE_HERO_BANNER } from '../../../constants/ErrorBoundaryNames';
import { hubToImage } from '../../../utils/trialHeroBannerImageUtils';
import { withErrorBoundary } from '../../ErrorBoundary';
import { TrialUpgradeBannerContent } from './TrialUpgradeBannerContent';

// MHP and OHP have an expanded pricing section, this is used to determine the padding
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SEATS_INCLUDED_API_NAMES = [MARKETING_HUB_PROFESSIONAL, OPERATIONS_HUB_PROFESSIONAL];
const UpgradeContentContainer = styled.div.withConfig({
  displayName: "TrialUpgradeHeroBanner__UpgradeContentContainer",
  componentId: "sc-1526go9-0"
})(["max-width:100%;position:absolute;top:0;left:10%;", ";", ";"], breakpoint.tablet(_t || (_t = _`
    padding-right: 48px;
    padding-left: 48px;
  `)), ({
  apiName
}) => SEATS_INCLUDED_API_NAMES.includes(apiName) ? `padding-top: 32px; padding-bottom: 32px;` : `padding-top: 64px; padding-bottom: 16px;`);
const HeroBackground = styled.div.attrs({
  role: 'banner'
}).withConfig({
  displayName: "TrialUpgradeHeroBanner__HeroBackground",
  componentId: "sc-1526go9-1"
})(["width:100%;background-color:", ";overflow:hidden;min-height:500px;position:relative;"], CALYPSO_LIGHT);
const StyledImage = styled(UIImage).withConfig({
  displayName: "TrialUpgradeHeroBanner__StyledImage",
  componentId: "sc-1526go9-2"
})(["width:50%;height:60%;max-width:100%;max-height:100%;position:absolute;bottom:0;right:0;margin:-5px;"]);
const HeroImage = ({
  apiName
}) => {
  return /*#__PURE__*/_jsx(StyledImage, {
    width: "100%",
    src: hubToImage(apiName)
  });
};
const TrialUpgradeHeroBanner = ({
  apiName
}) => {
  return /*#__PURE__*/_jsxs(HeroBackground, {
    children: [/*#__PURE__*/_jsx(UpgradeContentContainer, {
      apiName: apiName,
      className: "m-x-auto",
      children: /*#__PURE__*/_jsx(TrialUpgradeBannerContent, {
        apiName: apiName
      })
    }), /*#__PURE__*/_jsx(HeroImage, {
      apiName: apiName
    })]
  });
};
export default withErrorBoundary(TrialUpgradeHeroBanner, {
  boundaryName: TRIAL_UPGRADE_HERO_BANNER
});